var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 390"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 389"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 475",
    d: "M11.095 22.4801C4.993 22.4801 0 17.4871 0 11.3851C0 5.28206 4.993 0.289062 11.095 0.289062C17.197 0.289062 22.19 5.28206 22.19 11.3851C22.19 17.4871 17.197 22.4801 11.095 22.4801Z",
    fill: "#47A3DB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 476",
    d: "M5.14269 12.6609C6.18969 13.5369 7.22169 14.4359 8.28669 15.2899C8.99469 15.8569 9.90269 15.8829 10.4867 15.1199C10.8297 14.6709 11.1497 14.2099 11.5137 13.7759C13.0057 11.9989 14.7827 10.5139 16.7947 9.36087C18.1907 8.56187 16.9327 6.40087 15.5327 7.20287C14.1267 8.00787 12.8067 8.97287 11.6097 10.0659C11.0297 10.5959 10.4797 11.1589 9.96469 11.7519C9.70669 12.0489 9.45969 12.3539 9.21769 12.6639C9.08369 12.8359 8.94969 13.0099 8.81869 13.1849C8.75169 13.2749 8.68569 13.3659 8.61969 13.4569C8.46069 13.6609 8.49569 13.6439 8.72569 13.4079L9.68869 13.2819C9.92369 13.4259 9.97069 13.4429 9.82969 13.3339C9.75469 13.2719 9.68069 13.2089 9.60569 13.1459C9.50569 13.0629 9.40569 12.9789 9.30569 12.8959C9.03169 12.6669 8.75669 12.4369 8.48269 12.2079C7.95869 11.7689 7.43469 11.3309 6.91069 10.8929C6.39269 10.4609 5.64969 10.3859 5.14269 10.8929C4.69769 11.3379 4.62269 12.2259 5.14269 12.6609Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.76fa8de1ae719b3183f6f9698ab3cd83.svg";
export { ForwardRef as ReactComponent };